module.exports = __webpack_public_path__ + "static/media/battles-info-screen-3.27358cc7.png";